export default __webpack_public_path__ + "static/lli-420991fb83f5c4b2cbf77cfa4bdae0d3.jpeg";